export enum JournalsState {
    NotExist,
    Deleted,
    Disabled,
    Ok
}